import Footer from "../components/Footer";
import Hero from "../components/Hero";
import MarketUpdate from "../components/MarketUpdate";
import CryptoCoins from "../components/CryptoCoins";

function Home() {
  return (
    <>
      <Hero />
      <MarketUpdate />
      <CryptoCoins />
      <Footer />
    </>
  );
}

export default Home;
